export interface SnGeoJSONPoint {
  type: 'Point';
  coordinates: [number, number]; // [longitude, latitude]
}

export interface SnCadIncident {
  id: string;
  type: 'cad' | 'marker';
  createdTimestamp: string;
  updatedTimestamp: string;
  geometry: SnGeoJSONPoint;
  status: 'active' | 'closed';
  description: string;
  callType?: string;
  priority?: string;
}

export interface SnIncidentRequest {
  id: string;
  incidentId: string;
  type: 'drone';
  createdTimestamp: string;
  updatedTimestamp: string;
  provider: 'skydio';
  providerAssetId: string | null;
  status: 'active' | 'acknowledged' | 'declined' | 'closed';
  meta: Record<string, unknown>;
}

export interface SnIncidentsResponse {
  results: SnCadIncident[];
  pagination: {
    pageSize: number;
    hasMore: boolean;
    nextCursor: string | null;
  };
}

export interface SnIncidentRequestsResponse {
  results: SnIncidentRequest[];
  pagination: {
    pageSize: number;
    hasMore: boolean;
    nextCursor: string | null;
  };
}

export interface SnIncidentRequestsParams {
  from?: string;
  to?: string;
  status?: 'active' | 'acknowledged' | 'declined' | 'closed';
  cursor?: string;
  pageSize?: number;
}

export interface SnIncidentsParams {
  from?: string;
  to?: string;
  status?: 'active' | 'closed';
  cursor?: string;
  pageSize?: number;
}

export interface SnCreateIncidentRequestBody {
  type: 'drone';
  provider: 'skydio';
}

export interface SnUpdateIncidentRequestBody {
  status: 'active' | 'acknowledged' | 'declined' | 'closed';
  providerAssetId?: string;
  meta?: Record<string, unknown>;
}
